export default [
  {
    path: '/numerologies',
    name: 'numerologies',
    component: () => import('@/views/numerology/Numerology.vue'),
    meta: {
      pageTitle: 'Numerology',
      breadcrumb: [
        {
          text: 'Numerology',
          active: true,
        },
      ],
      requireAuth: true,
    },
  },
]
